import { Select } from '@creditornot/cb-select';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { SortOrder } from './types';

type ImageCoverageTypeSelectProps = {
  value?: SortOrder;
  onChange?: (value: SortOrder) => void;
};

const StyledSelect = styled(Select)`
  width: 200px;
  cursor: pointer;
`;

const ImageCoverageTypeSelect = ({ value, onChange }: ImageCoverageTypeSelectProps) => {
  const { formatMessage } = useIntl();

  const options = useMemo(
    () => [
      {
        label: formatMessage({ id: 'insights.menu.image-coverage.section.type-select.options.low' }),
        value: SortOrder.ASC,
      },
      {
        label: formatMessage({ id: 'insights.menu.image-coverage.section.type-select.options.high' }),
        value: SortOrder.DESC,
      },
    ],
    [formatMessage],
  );

  return <StyledSelect value={value} onChange={onChange} options={options} disableSearch />;
};

export default ImageCoverageTypeSelect;
